import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  isDark?: boolean;
}
export function Textarea({
  label,
  className = '',
  isDark = false,
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-218">
      {label && <label className={`block text-sm font-medium mb-2 ${isDark ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-219">
          {label}
        </label>}
      <textarea className={`w-full px-4 py-3 border rounded-xl placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200 min-h-[120px] resize-y ${isDark ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} ${className}`} {...props} data-id="element-220" />
    </div>;
}